import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../../hooks/useNotifications'
import { getKiosks } from '../../../../services/templeKioskService'
import useTempleLanguages from '../../../../hooks/useCardsLanguages'

export default function useTempleKiosks() {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [kiosks, setKiosks] = useState([])
  const [kioskSuggestions, setKioskSuggestions] = useState()
  const [kioskInputText, setKioskInputText] = useState('')
  const [filterByAuthorized, setFilterByAuthorized] = useState(false)
  const [selectedKiosk, setSelectedKiosk] = useState(null)
  const [isEditMode, setIsEditMode] = useState(false)
  const { languages } = useTempleLanguages()

  const kiosksState = {
    kiosks,
    kioskSuggestions,
    languages,
    filterByAuthorized,
    selectedKiosk,
    isEditMode,
    kioskInputText,
  }
  const kiosksActions = {
    setKiosks,
    setKioskSuggestions,
    setFilterByAuthorized,
    setSelectedKiosk,
    setIsEditMode,
    setKioskInputText,
  }

  useEffect(() => {
    let isCurrent = true
    getKiosks()
      .then((kiosksData) => {
        if (isCurrent) {
          setKiosks(kiosksData.data)
          setKioskSuggestions(
            kiosksData.data.map((kiosk, index) => {
              return {
                key: index,
                primaryText: `${kiosk.templeCode} - ${kiosk.locationDescription}`,
                secondaryText: kiosk.kioskId,
                authorized: kiosk.authorized,
              }
            })
          )
        }
      })
      .catch((err) => {
        error(
          t('temple.kiosks.getKiosks.error', `Failed to get kiosks: {message}`, { message: err?.response?.statusText }),
          err
        )
      })
    return () => {
      isCurrent = false
    }
  }, [error, t])

  return { kiosksState, kiosksActions }
}
